/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".noEvent[_ngcontent-%COMP%]{pointer-events:none}.hideIcon[_ngcontent-%COMP%]{opacity:0;pointer-events:none}"];
export { styles as styles };
